import DataProvider from '../../../lmm-widget/src/layers/dataProviders/_base/DataProvider';
import Utils from 'helpers/Utils';

export default DataProvider.extend({
	constructor(options) {
		this.widget = options.widget;
		this.options = options;
		this.initialize();
	},

	initialize() {
		this._checkVisibility();
		DataProvider.prototype.initialize.call(this);
	},

	load(destinationId) {
		let opt = {
			featureId: 'hotelCode',
			geometry: 'position'
		};
		this.widget.getDestinationsTreeObject(destinationId).then(hotelsData => {
			const bounds = new google.maps.LatLngBounds();
            hotelsData.forEach(hotel => {
                bounds.union(
                    Utils.getBoundsFromPoint(
                        new google.maps.LatLng({
                            lat: hotel.position.lat,
                            lng: hotel.position.lon
                        }),
                        10
                    )
                );
            });
			this.widget.map.fitBounds(bounds);
			this.trigger(
				'PROCESS_FEATURES',
				Utils.transformDataToGeoJSON(
					{ features: hotelsData },
					opt
				).features,
				this
			);
		});
        this.widget.$el.find('.lmm-main-box-hotel-detail-panel').hide();
        this.widget.$el.find('.lmm-hotel-resume-mobile-panel').hide();
	}
});



// WEBPACK FOOTER //
// ./src/layers/providers/DestinationsTreeProvider.js